export enum WearableGender {
  MALE = 'male',
  FEMALE = 'female'
}
